import React from "react";

// Sidebar section listing every editable field on the SPB template,
// grouped by role. Clicking a chip selects the field for the property
// editor above.
export default function FieldListPanel({ groups, selectedId, onSelect }) {
  return (
    <div className="border-t border-border pt-3">
      <div className="overline mb-2">Daftar Field</div>
      <div className="max-h-72 overflow-y-auto space-y-2 pr-1">
        {groups.map((g) => (
          <div key={g.label}>
            <div className="overline text-[10px] mb-1">{g.label}</div>
            <div className="flex flex-wrap gap-1">
              {g.ids.map((id) => (
                <button
                  key={id}
                  onClick={() => onSelect(id)}
                  className={`px-2 py-1 text-[10px] font-mono border ${
                    selectedId === id
                      ? "bg-primary text-primary-foreground border-primary"
                      : "border-border hover:bg-secondary"
                  }`}
                >
                  {id}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
